import metadata from './site-metadata.json';

export const SITE = 'https://jennaemichelle.com';
export const SOCIAL_IMAGE = `${SITE}/brand/holdings-framed-approved.png`;
export function pageMetadata(pathname, title, description) {
  const path = pathname.replace(/\/+$/, '') || '/';
  const saved = metadata[path];
  const privatePage = /^\/(founder|login|legal|secure-intake)(\/|$)/.test(path);
  const name = saved?.title || title || 'Page Not Found';
  return {
    title: name === 'Jennae Michelle Holdings' ? name : `${name} — Jennae Michelle Holdings`,
    description: saved?.description || description || 'Jennae Michelle Holdings, LLC.',
    canonical: saved?.canonical || `${SITE}${path}`,
    robots: saved?.index && !privatePage ? 'index, follow' : 'noindex, follow',
  };
}
export function organizationSchema() {
  return {
    '@context': 'https://schema.org', '@type': 'Organization',
    '@id': `${SITE}/#organization`, name: 'Jennae Michelle Holdings',
    legalName: 'Jennae Michelle Holdings, LLC', url: `${SITE}/`,
    logo: `${SITE}/brand/jmh-20260929-512.png`,
    slogan: 'When nothing is certain, anything is possible.',
    email: 'admin@jennaemichelle.com', telephone: '+1-717-660-6091',
    address: { '@type': 'PostalAddress', postOfficeBoxNumber: '29', addressLocality: 'Lebanon', addressRegion: 'PA', postalCode: '17042', addressCountry: 'US' },
    founder: { '@type': 'Person', '@id': `${SITE}/about#founder`, name: 'Jennae Michelle Tropea', jobTitle: 'Founder & CEO', url: `${SITE}/about` },
  };
}
